module.exports = __webpack_public_path__ + "media/images/flags/IS-e9445f300e4758ac0ff60778b58cd0cf.svg";